import React from 'react';

export const Delete: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      d="M7.7 15.9c.3 0 .6-.3.6-.6V7.7c0-.3-.3-.6-.6-.6s-.6.3-.6.6v7.6c.1.3.3.6.6.6zm4.6 0c.3 0 .6-.3.6-.6V7.7c0-.3-.3-.6-.6-.6s-.6.3-.6.6v7.6c0 .3.2.6.6.6z"
      fill="currentColor"
    />
    <path
      d="M19.4 3h-5.1V2c0-1.1-.8-1.9-1.9-2H7.5c-1 0-1.9.9-1.9 1.9V3H.5c-.3.1-.5.3-.5.6s.2.5.5.5h1.7l.9 14c.1 1 .9 1.8 1.9 1.8h9.8c1 0 1.9-.8 1.9-1.8l.9-14h1.7c.3 0 .5-.3.5-.6.1-.2-.1-.4-.4-.5zM6.7 2c0-.5.3-.8.8-.8h4.9c.5 0 .8.4.8.8v1H6.7V2zm9 16.1c0 .4-.4.8-.8.8H5.1c-.4 0-.8-.3-.8-.8L3.4 4.2h13.2l-.9 13.9z"
      fill="currentColor"
    />
  </svg>
);
